// extracted by mini-css-extract-plugin
export default {"background":"OibT9","overlay":"JVm0O","skeleton":"L017a","star":"caOcH","roundStar":"iiknV","redStar":"a6IOu","redRoundStar":"X3ZkF"};